<template>
  <div id="app">
    <AppNavbar />
    <div class="main-content">
      <router-view />
    </div>
    <footer class="app-footer">
      <span>职卫云旗下 · 职业健康智能题库</span>
      <ExternalBrandLink surface="footer" aria-label="在新窗口打开职卫云官网（页脚）" />
    </footer>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from './stores/auth'
import AppNavbar from './components/layout/AppNavbar.vue'
import ExternalBrandLink from './components/recommendations/ExternalBrandLink.vue'

const router = useRouter()
const authStore = useAuthStore()

// 应用初始化
onMounted(() => {
  // 尝试从本地存储恢复认证状态
  authStore.restoreAuth()
})
</script>

<style scoped>
#app {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-attachment: fixed;
  position: relative;
  display: flex;
  flex-direction: column;
}

#app::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(120, 119, 198, 0.2) 0%, transparent 50%);
  pointer-events: none;
  z-index: -1;
}

.main-content {
  min-height: calc(100vh - 56px);
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 0;
  position: relative;
  flex: 1;
}

.app-footer { position: relative; display: flex; justify-content: center; align-items: center; flex-wrap: wrap; gap: .75rem; padding: 1rem; background: rgba(35, 31, 71, .92); color: #fff; font-size: .9rem; }

@media (max-width: 768px) {
  .main-content {
    padding-top: 0.5rem;
    background: rgba(255, 255, 255, 0.08);
  }
}
</style>
